module.exports = __webpack_public_path__ + "static/media/otp.7626fb99.png";